module.exports = __webpack_public_path__ + "static/FAVT_banner_mobile.3cd432e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/FAVT_banner_mobile.png
// module id = 980
// module chunks = 101932004231744